import {FC, useEffect, useState} from 'react'
import Content from "../main/Content";
import Calendar from "../common/Calendar";
import {getCalendar} from "../../wordpress/operations/get-calendar";
import {getWorkshops} from "../../wordpress/operations/get-workshops";
import WorkshopSelect from "./WorkshopSelect";
import {bookingCalendar} from "../../constants/global";
import Submission from "../Submission";
import Offers from "../Campaign";
import DateCarousel from "./DateCarousel";
import {getBookingFlowStepNum} from "../../lib/booking";
import NavNextPrev from "../common/NavNextPrev/NavNextPrev";

interface Props {
    booking: Booking
    pageContent:ContentPage,
    setBooking: Function,
    content:any
}

const Date: FC<Props> = ({ pageContent, booking, setBooking, content }) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    // Workshops
    const [workshops, setWorkshops] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    if(!workshops) {
        getWorkshops(booking).then((val) => {
            if(val.error) {
                setWorkshops([])
                return
            }

            // Check if active calendar resource and workshop is available
            let clear_booking_resource = true;
            for(let i=0; i<val.length; i++) {
                if(val[i].id === booking.resource && booking.workshop == val[i].workshop_id)
                    clear_booking_resource = false
            }

            if(clear_booking_resource)
                setBooking({...booking, resource: val[0].id})

            // Ingen verkstad förväljs; kalendern laddas först när kunden valt en.
            setWorkshops(val)
        })
    }

    // Calendar
    const [month, setMonth] = useState<any>(null);
    const getMonth = (date:string='') => {
        if(!loading && booking.service.id && booking.workshop) {
            setLoading(true)
            getCalendar(booking, date).then((val) => {
                setLoading(false)
                bookingCalendar.slots = []
                setBooking({...booking, resourceId: val.resourceId})
                setMonth(val)
            })
        }
    }

    if(!workshops)
        return

    if(workshops.length === 0)
        return (
            <div className="input-outer">
                <div className="row mobile-reverse">
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12">
                        <Submission booking={booking} setBooking={setBooking} content={content} />
                    </div>
                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12">
                        <Content booking={booking} content={pageContent}/>
                        <div className={'submission_area'}>
                            Fel: inga tider hittades.
                        </div>
                    </div>
                </div>
            </div>
        )

    if(!month) {
        getMonth(booking.date)
    }

    const num = getBookingFlowStepNum(booking);
    let heading = pageContent.title;
    if(num && !booking.hjulskifte_update) {
        heading = num + '. ' + pageContent.title;
    }


    return (
        <div className="input-outer">
            <div className="row mobile-reverse">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12">
                    {!booking.hjulskifte_update && (
                        <Offers booking={booking} setBooking={setBooking}/>
                    )}
                </div>
                <div className="main-bg col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12">
                    <div className="text-content">
                        <h2>{heading}</h2>
                        <DateCarousel booking={booking} setBooking={setBooking} content={content}/>
                        <div dangerouslySetInnerHTML={pageContent.content}/>
                        {booking.hjulskifte_update && (
                            <div className={"hjulskifte-update"}>
                                <div className={"hjulskifte-update__time"}>Bokad tid: {booking.hjulskifte_update.date} | {booking.hjulskifte_update.time}</div>
                                <div className={"hjulskifte-update__time"}>Ny tid: {booking.date} {booking.submission.time && (<>|</>)} {booking.submission.time}</div>
                            </div>
                        )}
                    </div>
                    <div className={'submission_area'} id={"date-picker"}>
                        <WorkshopSelect workshops={workshops} booking={booking} setBooking={setBooking}
                                        loading={loading} getMonth={getMonth}/>
                        {loading ? (
                            <>
                                <div className={"calendar-loader"}>
                                    <div className="loader_dots">
                                        <span className="loader__dot">.</span>
                                        <span className="loader__dot">.</span>
                                        <span className="loader__dot">.</span>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <Calendar calendar={month} booking={booking} setBooking={setBooking} getMonth={getMonth}
                                      content={content}/>)
                        }

                    </div>
                    {booking.calendar_carousel.steps[booking.calendar_carousel.index].slug === 'submissions' ? (
                        <Submission booking={booking} setBooking={setBooking} content={content}/>
                    ) : ''}
                    <div>
                        <NavNextPrev booking={booking} setBooking={setBooking} content={content}/>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Date
